import { render, staticRenderFns } from "./CadastroSinalizadorGen.vue?vue&type=template&id=75bfb052&"
import script from "./CadastroSinalizadorGen.vue?vue&type=script&lang=js&"
export * from "./CadastroSinalizadorGen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports